import {
  InputField,
  IInputField,
} from "@clover/rrs-components/components/_form/InputField/InputField";
import { useEffect, useRef } from "react";

export interface StyledInputFieldProps extends IInputField {
  merchantColor?: string;
  srLabel?: string;
}

export const StyledInputField = (props: StyledInputFieldProps) => {
  const { theme = {}, merchantColor, srLabel, ...rest } = props;
  const nativeInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (srLabel && nativeInputRef.current) {
      nativeInputRef.current.setAttribute("aria-label", srLabel);
    }
  }, [srLabel]);

  return (
    <InputField
      inputRef={nativeInputRef}
      {...rest}
      theme={{
        "& .MuiInputLabel-root": {
          left: "-5px",
          "&.Mui-focused": {
            color: merchantColor,
          },
        },
        "& .MuiInputLabel-shrink": {
          transform: "translate(15px, 8px) scale(0.80)",
          paddingBottom: "0px",
          backgroundColor: "transparent",
        },
        "& .MuiOutlinedInput-root": {
          "& input": {
            paddingTop: "24px",
            paddingBottom: "6px",
            paddingLeft: "10px",
            fontSize: "16px",
          },
          "&.Mui-focused fieldset": {
            borderColor: merchantColor,
          },
          "& fieldset": {
            top: 0,
            borderColor: "#727272",
          },
        },
        "& .MuiOutlinedInput-notchedOutline legend": {
          display: "none",
        },
        "& .MuiFormHelperText-root": {
          marginLeft: "1px",
        },
        ...theme,
      }}
    />
  );
};
